<script setup>
import { __, setFormFragmentValues, getFormValuesFromLocalStorage } from '@/utils';
import { ref, inject, computed } from 'vue';
import IconSmartphone from '@components/icons/icon-smartphone.vue';
import IconDelivery from '@components/icons/icon-delivery.vue';
import IconDeliverySim from '@components/icons/icon-delivery-sim.vue';
import IconDelivery2 from '@components/icons/icon-delivery2.vue';

const { startActivation, showSuccessPage, registrationData } = inject('step');

const localStorageValues = getFormValuesFromLocalStorage();
const shippingMethod = ref(localStorageValues.subscriberShippingMethod);

const startActivationProcess = () => {
    showSuccessPage. value = false;
    startActivation.value = true;

    setFormFragmentValues({
        showSuccessPage: showSuccessPage.value,
        startActivation: startActivation.value
    });
}

const esimNumbers = computed(() => registrationData.value?.subscribers?.filter(subscriber => subscriber.sim?.is_esim) || []);
const simNumbers = computed(() => registrationData.value?.subscribers?.filter(subscriber => !subscriber.sim?.is_esim) || []);

const numberType = (isPorted) => isPorted ? __('Mobile subscription') : __('New line subscription');

const cleanLocalStorage = () => {
    // cleanup
    localStorage.removeItem('formValues');
    localStorage.removeItem('formFragmentValues');
}
</script>
<template>
    <div class="mixed-wrapper">
        <div class="cols">
            <div class="col__item">
                <h4>{{ __('Lines with an ESIM card:') }}</h4>
                <p>{{ __('Your ESIM cards can be activated') }}</p>
                <div class="number-boxes">
                    <span class="number-box" v-for="number in esimNumbers" :key="number.id">
                        <div class="pill">
                            <div class="pill__inner">
                                {{ number.msisdn }}
                                <div class="pill__icon">
                                    <IconSmartphone />
                                </div>
                            </div>
                        </div>
                        <div class="number-box__text">

                            {{ numberType(number.is_ported) }}
                        </div>
                    </span>
                </div>
                <div class="mixed-wrapper__button">
                    <!-- <button type="button" class="btn btn--arrows" @click="startActivationProcess">
                        {{ __('Continue activating ESIM') }}
                    </button> -->
                    <a href="/activation" class="btn btn--arows">
                        {{ __('Continue activating ESIM') }}
                    </a>
                </div>
            </div>
            <div class="col__item">
                <h4>{{ __('Lines with a physical SIM Cards:') }}</h4>
                <p>
                    {{ __('You can activate them when they reach you') }} ({{ shippingMethod === 'regular' ? __('Israel Post - up to 7 business days') : __('Home delivery - up to 3 business days') }})
                </p>
                <div class="number-boxes" v-if="simNumbers?.length">
                    <span class="pill" v-for="number in simNumbers" :key="number.msisdn">
                        <div class="pill__inner">
                            {{ number.msisdn }}
                            <div class="pill__icon">
                                <IconSmartphone />
                            </div>
                        </div>
                    </span>
                </div>
                <div class="mixed-list">
                    <div class="mixed-list__item">
                        <div class="mixed-list__icon">
                            <IconDelivery />
                        </div>
                        <div class="mixed-list__text">
                            <h5 class="gradient">01</h5>
                            <h5>{{ __('The SIM arrived by delivery') }}</h5>
                            <p>{{ shippingMethod === 'regular' ? __('Israel Post - up to 7 business days') : __('Home delivery - up to 3 business days') }}</p>
                        </div>
                    </div>

                    <div class="mixed-list__item">
                        <div class="mixed-list__icon">
                            <IconDeliverySim />
                        </div>
                        <div class="mixed-list__text">
                            <h5 class="gradient">02</h5>
                            <h5>{{ __('Get the sim and activate') }}</h5>
                            <p>{{ __('Follow the instructions attached to the shipment, and in any case our call center is here for you') }}</p>
                        </div>
                    </div>

                    <div class="mixed-list__item">
                        <div class="mixed-list__icon">
                            <IconDelivery2 />
                        </div>
                        <div class="mixed-list__text">
                            <h5 class="gradient">03</h5>
                            <h5>{{ __('Connect to XPhone') }}</h5>
                            <p>{{ __("And that's it, you're connected") }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <a href="/" class="btn btn--arrows" @click="cleanLocalStorage">
        {{ __('Back to Home page') }}
    </a>
</template>